/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GenericApiResponse_GeneratePershingSsoTokenResponseDto } from '../models/GenericApiResponse_GeneratePershingSsoTokenResponseDto';
import type { Wealthlane_Dtos_SsoProvider_InitiatePershingSsoRequestDto } from '../models/Wealthlane_Dtos_SsoProvider_InitiatePershingSsoRequestDto';
import type { Wealthlane_Dtos_SsoProvider_PershingSsoEligibilityResponseDto } from '../models/Wealthlane_Dtos_SsoProvider_PershingSsoEligibilityResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PershingSsoService {

    /**
     * @param requestBody 
     * @returns GenericApiResponse_GeneratePershingSsoTokenResponseDto OK
     * @throws ApiError
     */
    public static postApiIdentityApiAppPershingSsoGenerateToken(
requestBody?: Wealthlane_Dtos_SsoProvider_InitiatePershingSsoRequestDto,
): CancelablePromise<GenericApiResponse_GeneratePershingSsoTokenResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/identity/api/app/pershing-sso/generate-token',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param participantId 
     * @returns GenericApiResponse_GeneratePershingSsoTokenResponseDto OK
     * @throws ApiError
     */
    public static postApiIdentityApiAppPershingSsoGenerateTokenForParticipant(
participantId: string,
): CancelablePromise<GenericApiResponse_GeneratePershingSsoTokenResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/identity/api/app/pershing-sso/generate-token-for-participant/{participantId}',
            path: {
                'participantId': participantId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_Dtos_SsoProvider_PershingSsoEligibilityResponseDto OK
     * @throws ApiError
     */
    public static postApiIdentityApiAppPershingSsoCheckEligibility(): CancelablePromise<Wealthlane_Dtos_SsoProvider_PershingSsoEligibilityResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/identity/api/app/pershing-sso/check-eligibility',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param participantId 
     * @returns Wealthlane_Dtos_SsoProvider_PershingSsoEligibilityResponseDto OK
     * @throws ApiError
     */
    public static postApiIdentityApiAppPershingSsoCheckParticipantEligibility(
participantId: string,
): CancelablePromise<Wealthlane_Dtos_SsoProvider_PershingSsoEligibilityResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/identity/api/app/pershing-sso/check-participant-eligibility/{participantId}',
            path: {
                'participantId': participantId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
